import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import DeleteIcon from "@mui/icons-material/Delete";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const DeleteAttestationDialog = ({ id, attestationId, fetchAttestations }) => {
  const notify = useNotify();

  const handleDelete = async () => {
    await dataProvider.customRequest(
      graduationRequests.deleteStudentMonthlyInternshipAttestation(id, attestationId),
      null,
      "DELETE",
    );
    fetchAttestations();
    notify("Успешно изтриване на заверка за месечен стаж", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleDelete}
      titleContent={"Изтриване на заверка за месечен стаж"}
      message="Сигурни ли сте, че искате да изтриете заверката?"
      triggerButton={
        <Button
          label="Изтрий"
          startIcon={<DeleteIcon />}
          color="error"
        />
      }
    />
  );
};

export default DeleteAttestationDialog;
